export interface LaufZeitpunkt {
  key: 'minuten' | 'stunden' | 'gestern' | 'tage';
  n?: number;
}

const MINUTE = 60_000;

export function laufZeitpunkt(ende: Date, jetzt: Date): LaufZeitpunkt {
  const minuten = Math.floor((jetzt.getTime() - ende.getTime()) / MINUTE);
  if (minuten < 60) return { key: 'minuten', n: Math.max(1, minuten) };

  const tage = kalendertag(jetzt) - kalendertag(ende);
  if (tage === 0) return { key: 'stunden', n: Math.floor(minuten / 60) };
  if (tage === 1) return { key: 'gestern' };
  return { key: 'tage', n: tage };
}

function kalendertag(datum: Date): number {
  return Math.round(new Date(datum.getFullYear(), datum.getMonth(), datum.getDate()).getTime() / (24 * 60 * MINUTE));
}
